import { createApp } from 'vue';
import { router  } from './routes.js';
import App from './App.vue';

//createApp(App).mount('#app')
const app = createApp(App);
app.use(router);
app.mount('#app');